module.exports = __webpack_public_path__ + "img/ISA-ML (1).241974d5.png";